
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_Fde_45yG3Bc1E9Din_wT62z7_pdxSYQemRDN2q59tfMwMeta } from "/opt/carify/website/pages/index.vue?macro=true";
import { default as jobspKyjyN4JP8EwHbRXErR5nKIpm0_8Dcr8IkXe5jeLxYIMeta } from "/opt/carify/website/pages/jobs.vue?macro=true";
import { default as dealsSqAj2_Ef95ZrD5wBBBZQULoY1whoKQTg53cHB6jOmJ4Meta } from "/opt/carify/website/pages/deals.vue?macro=true";
import { default as presshCMZgMuTTqgBJXCCpHIb0sUrEhwUV9baX24C2HwHIfIMeta } from "/opt/carify/website/pages/press.vue?macro=true";
import { default as companyEVX3At3JRrhtvyLl8pgi5BOYk_20ivGfCd51QPvKnWMMeta } from "/opt/carify/website/pages/company.vue?macro=true";
import { default as leasingLhv8VNg8c2sEaWiNHEUJ_45ixEQSSvMkpIlyQNB7MD7ywMeta } from "/opt/carify/website/pages/leasing.vue?macro=true";
import { default as llm_45info6OtLMS_45Ze997IA6NlfpI5UcgiF9rtjkao8B3_T_45Wh58Meta } from "/opt/carify/website/pages/llm-info.vue?macro=true";
import { default as _91id_93dqI60JW4uE8jnn4IE6Pb7RzAhyQW_45W7C1Tg2QMgKBT4Meta } from "/opt/carify/website/pages/as24/[id].vue?macro=true";
import { default as changelogjhGti5ZAAj5HQ1f7U9PnM_cfDb6cObvE2sj8SrvBaoMMeta } from "/opt/carify/website/pages/changelog.vue?macro=true";
import { default as demo_45pagen08U_453m2B4ojR0M3deKi7fn6Jcwzia1OWytl42IHOnYMeta } from "/opt/carify/website/pages/demo-page.vue?macro=true";
import { default as impressumR18TweozByoX9scrYmeiA6gmRN8AavXbRPErFui__LUMeta } from "/opt/carify/website/pages/impressum.vue?macro=true";
import { default as index7VKvRaWfJ5OmSW2IgLmpM3vEcAtk2XIycEboPjjmOuYMeta } from "/opt/carify/website/pages/blog/index.vue?macro=true";
import { default as contact_45us1twtzpiK07rs8280F6CF01CSHDlbzZyYz640nyRHC7oMeta } from "/opt/carify/website/pages/contact-us.vue?macro=true";
import { default as _91slug_93_ebUTq2AhUcXxQlWyh7dcM2rYeBvq2Jdecj5qHeypSIMeta } from "/opt/carify/website/pages/blog/[slug].vue?macro=true";
import { default as try_45and_45buyEed8LdqBq0KcbXaMeiuXCIp7L8PfuFdqExldq1m0LnYMeta } from "/opt/carify/website/pages/try-and-buy.vue?macro=true";
import { default as loginkqWOgxsCqSYHhQcV3PsTY2Axfc4FpQok6javG_45qny6gMeta } from "/opt/carify/website/pages/users/login.vue?macro=true";
import { default as indexkT6aCf3moZA_45flXcDy_yGw_45Ib_y_j_KZIWGXFS0_45Xa4Meta } from "/opt/carify/website/pages/brands/index.vue?macro=true";
import { default as how_45it_45workskCKo6Akgqd7yHL28DWzVR6F_450uoIbai9Aq2brn4p6C4Meta } from "/opt/carify/website/pages/how-it-works.vue?macro=true";
import { default as _91slug_93m2uF41_45nIjroSEZM6CxbmC1zduwk2h46QKG8aSEk_n4Meta } from "/opt/carify/website/pages/brands/[slug].vue?macro=true";
import { default as index9_czIm3M0OdKdJGvNJYr_X4grSn1ddMWNGnYyaPjLOIMeta } from "/opt/carify/website/pages/dealers/index.vue?macro=true";
import { default as electric_45carsInxNjzm1FEEtfQEQJXh10vDH4_OBU712s_45MKJEobaI4Meta } from "/opt/carify/website/pages/electric-cars.vue?macro=true";
import { default as profileXqmjesIGbqoiW09Hl4C57i3du_45blzL5fgrr_huLBIvMMeta } from "/opt/carify/website/pages/users/profile.vue?macro=true";
import { default as sign_45upXUCNoxxLcBxo1akWRtU8h_45tcWAWUOqbqaQF4qwbyUEcMeta } from "/opt/carify/website/pages/users/sign-up.vue?macro=true";
import { default as _91slug_93PE6MMT1gfdHdVjUNpN4lWo6hXeH28Mr_459mUDAXlFT0wMeta } from "/opt/carify/website/pages/dealers/[slug].vue?macro=true";
import { default as expat_45auto_45abox52rWwFnCDX6vCijFLJTlHRz3I5Gw45qkVY2rKJUMisMeta } from "/opt/carify/website/pages/expat-auto-abo.vue?macro=true";
import { default as privacy_45policyVjDT_45oyf90zgA5nUW4JVeA0WsuCJVfaeZD4hEFpUdNUMeta } from "/opt/carify/website/pages/privacy-policy.vue?macro=true";
import { default as search_45vehicles_n2S9PO7bp4vYqAIG7PUA7QQmprmxS3Q9UsMzhFMK_4Meta } from "/opt/carify/website/pages/search-vehicles.vue?macro=true";
import { default as vehicle_45configs2wxUm5VnT_45O7oZxnQmGG8qq72LA5AL3n6ydeqfhjzjIMeta } from "/opt/carify/website/pages/vehicle-configs.vue?macro=true";
import { default as _91slug_93fT0cMP5iKWVF_FRjzJJ4HiyosYFG8_45h2_97Va3g3JPcMeta } from "/opt/carify/website/pages/vehicles/[slug].vue?macro=true";
import { default as become_45a_45partnerjrGXVzfQ5LD8LVtLC7K8VHOLb38D3IfF2m_45DPTZ7eiMMeta } from "/opt/carify/website/pages/become-a-partner.vue?macro=true";
import { default as compare_45vehiclescmnfXcbNm0gM_NH49jMfchNM7KoVDcbfYcdeafs_hckMeta } from "/opt/carify/website/pages/compare-vehicles.vue?macro=true";
import { default as _91id_93KiKAfdJyO7yYeqyvdfWuNJTbAPHGxXubk0ZWV4L3VEgMeta } from "/opt/carify/website/pages/view/[slug]/[id].vue?macro=true";
import { default as affiliate_45programYAPI1d2NBisjjWZQmMSCQYGaGQKAGNQr40jGQo9DSusMeta } from "/opt/carify/website/pages/affiliate-program.vue?macro=true";
import { default as business_45customersOka9805q2GavX0macZy132VUt5hg8VFBkH95H6nbda8Meta } from "/opt/carify/website/pages/business-customers.vue?macro=true";
import { default as verify_emailPYck9TML1qvg5ShrxibWSwmOV2G5Rbt5S2rULEDFoFQMeta } from "/opt/carify/website/pages/users/verify_email.vue?macro=true";
import { default as _91id_93twlqyNVeGpv7Sa6_PnJiS0ASZ5lhjJUZ_452OhCKSLWSUMeta } from "/opt/carify/website/pages/book_now/[slug]/[id].vue?macro=true";
import { default as _91abo_93DO0eZsiHXj0ZJrEfVyYDq9KiQw_gykc70X6_8LEOBlYMeta } from "/opt/carify/website/pages/brands/[brand]/[abo].vue?macro=true";
import { default as terms_45and_45conditionsQ04J_glgn_7fgqHsbf_45bj91ABePCUlUIjsCO0ktaCyMMeta } from "/opt/carify/website/pages/terms-and-conditions.vue?macro=true";
import { default as reset_passwordV9ZMZ_49agJTbQh0dWX2Ap6sMgSJwqDI2GFK7vE2ddoMeta } from "/opt/carify/website/pages/users/reset_password.vue?macro=true";
import { default as forgot_passwordA5X0NpL0Q91Eug_OM9mEyH3o3VZVe_45UtGIsDCV4svdgMeta } from "/opt/carify/website/pages/users/forgot_password.vue?macro=true";
import { default as _91id_93p6o53tOruKklS99UxL41vMN7iqPAmZ_S3fSqytAr_45fQMeta } from "/opt/carify/website/pages/users/km_request/[id].vue?macro=true";
import { default as _91id_93wmvCnfyhxlrhU9AG3fpGHF4WQRDBuYXeImE_45Z_45mXiiIMeta } from "/opt/carify/website/pages/claim_declarations/[id].vue?macro=true";
import { default as _91id_93DX7a3psfI0FwBl2MGhl3XASqmL_45nn00w83ShxLVRMrIMeta } from "/opt/carify/website/pages/claim_shared_files/[id].vue?macro=true";
import { default as frequently_45asked_45questionskn1BYGnisZ9tXBXhbGeNSkRdD03fccy_HaHwsUjbASUMeta } from "/opt/carify/website/pages/frequently-asked-questions.vue?macro=true";
import { default as short_45term_45car_45subscription3q2tuaebH9PVA6SObgmV7ce9uyakmN0QsTaj2D4TIOkMeta } from "/opt/carify/website/pages/short-term-car-subscription.vue?macro=true";
import { default as _91id_93Gp72a6FdLnvaEoC0DjlwPqnSeTj0Y1jnL991IiCk8aUMeta } from "/opt/carify/website/pages/tyrechange_appointment/[id].vue?macro=true";
import { default as _91id_93Jw0FpKgxUJebrcj2gLWcbquEL5JjieyUcf5OW9hknZIMeta } from "/opt/carify/website/pages/booking_document_request/[id].vue?macro=true";
import { default as car_45for_45students_45in_45switzerland9ir6bQ9I8zXXyNXb0AnX2pn4BaFUpm2lI7X5IhfkfqUMeta } from "/opt/carify/website/pages/car-for-students-in-switzerland.vue?macro=true";
import { default as long_45term_45car_45subscription_45switzerlandZbrFZ8UysD_45MDmBnP1IOcn5YmB8GHbUIdtHdM29o33gMeta } from "/opt/carify/website/pages/long-term-car-subscription-switzerland.vue?macro=true";
import { default as component_45stubfGHRWTin7UW9RdGD7KiDT1hVy5E2Q0cbky_45hmHtUduoMeta } from "/opt/carify/website/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubfGHRWTin7UW9RdGD7KiDT1hVy5E2Q0cbky_45hmHtUduo } from "/opt/carify/website/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/carify/website/pages/index.vue")
  },
  {
    name: "jobs___en",
    path: "/en/jobs",
    component: () => import("/opt/carify/website/pages/jobs.vue")
  },
  {
    name: "jobs___de",
    path: "/de/jobs",
    component: () => import("/opt/carify/website/pages/jobs.vue")
  },
  {
    name: "jobs___fr",
    path: "/fr/jobs",
    component: () => import("/opt/carify/website/pages/jobs.vue")
  },
  {
    name: "jobs___it",
    path: "/it/jobs",
    component: () => import("/opt/carify/website/pages/jobs.vue")
  },
  {
    name: "deals___en",
    path: "/en/deals",
    component: () => import("/opt/carify/website/pages/deals.vue")
  },
  {
    name: "deals___de",
    path: "/de/deals",
    component: () => import("/opt/carify/website/pages/deals.vue")
  },
  {
    name: "deals___fr",
    path: "/fr/deals",
    component: () => import("/opt/carify/website/pages/deals.vue")
  },
  {
    name: "deals___it",
    path: "/it/deals",
    component: () => import("/opt/carify/website/pages/deals.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/carify/website/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/carify/website/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/carify/website/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/opt/carify/website/pages/index.vue")
  },
  {
    name: "press___en",
    path: "/en/press",
    component: () => import("/opt/carify/website/pages/press.vue")
  },
  {
    name: "press___de",
    path: "/de/press",
    component: () => import("/opt/carify/website/pages/press.vue")
  },
  {
    name: "press___fr",
    path: "/fr/press",
    component: () => import("/opt/carify/website/pages/press.vue")
  },
  {
    name: "press___it",
    path: "/it/press",
    component: () => import("/opt/carify/website/pages/press.vue")
  },
  {
    name: "company___en",
    path: "/en/company",
    component: () => import("/opt/carify/website/pages/company.vue")
  },
  {
    name: "company___de",
    path: "/de/company",
    component: () => import("/opt/carify/website/pages/company.vue")
  },
  {
    name: "company___fr",
    path: "/fr/company",
    component: () => import("/opt/carify/website/pages/company.vue")
  },
  {
    name: "company___it",
    path: "/it/company",
    component: () => import("/opt/carify/website/pages/company.vue")
  },
  {
    name: "leasing___en",
    path: "/en/leasing",
    component: () => import("/opt/carify/website/pages/leasing.vue")
  },
  {
    name: "leasing___de",
    path: "/de/leasing",
    component: () => import("/opt/carify/website/pages/leasing.vue")
  },
  {
    name: "leasing___fr",
    path: "/fr/leasing",
    component: () => import("/opt/carify/website/pages/leasing.vue")
  },
  {
    name: "leasing___it",
    path: "/it/leasing",
    component: () => import("/opt/carify/website/pages/leasing.vue")
  },
  {
    name: "llm-info",
    path: "/llm-info",
    component: () => import("/opt/carify/website/pages/llm-info.vue")
  },
  {
    name: "as24-id___en",
    path: "/en/as24/:id()",
    component: () => import("/opt/carify/website/pages/as24/[id].vue")
  },
  {
    name: "as24-id___de",
    path: "/de/as24/:id()",
    component: () => import("/opt/carify/website/pages/as24/[id].vue")
  },
  {
    name: "as24-id___fr",
    path: "/fr/as24/:id()",
    component: () => import("/opt/carify/website/pages/as24/[id].vue")
  },
  {
    name: "as24-id___it",
    path: "/it/as24/:id()",
    component: () => import("/opt/carify/website/pages/as24/[id].vue")
  },
  {
    name: "changelog___en",
    path: "/en/changelog",
    meta: { ...(changelogjhGti5ZAAj5HQ1f7U9PnM_cfDb6cObvE2sj8SrvBaoMMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/carify/website/pages/changelog.vue")
  },
  {
    name: "changelog___de",
    path: "/de/changelog",
    meta: { ...(changelogjhGti5ZAAj5HQ1f7U9PnM_cfDb6cObvE2sj8SrvBaoMMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/carify/website/pages/changelog.vue")
  },
  {
    name: "changelog___fr",
    path: "/fr/changelog",
    meta: { ...(changelogjhGti5ZAAj5HQ1f7U9PnM_cfDb6cObvE2sj8SrvBaoMMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/carify/website/pages/changelog.vue")
  },
  {
    name: "changelog___it",
    path: "/it/changelog",
    meta: { ...(changelogjhGti5ZAAj5HQ1f7U9PnM_cfDb6cObvE2sj8SrvBaoMMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/carify/website/pages/changelog.vue")
  },
  {
    name: "demo-page___en",
    path: "/en/demo-page",
    component: () => import("/opt/carify/website/pages/demo-page.vue")
  },
  {
    name: "demo-page___de",
    path: "/de/demo-page",
    component: () => import("/opt/carify/website/pages/demo-page.vue")
  },
  {
    name: "demo-page___fr",
    path: "/fr/demo-page",
    component: () => import("/opt/carify/website/pages/demo-page.vue")
  },
  {
    name: "demo-page___it",
    path: "/it/demo-page",
    component: () => import("/opt/carify/website/pages/demo-page.vue")
  },
  {
    name: "impressum___en",
    path: "/en/impressum",
    component: () => import("/opt/carify/website/pages/impressum.vue")
  },
  {
    name: "impressum___de",
    path: "/de/impressum",
    component: () => import("/opt/carify/website/pages/impressum.vue")
  },
  {
    name: "impressum___fr",
    path: "/fr/impressum",
    component: () => import("/opt/carify/website/pages/impressum.vue")
  },
  {
    name: "impressum___it",
    path: "/it/impressum",
    component: () => import("/opt/carify/website/pages/impressum.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/opt/carify/website/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    component: () => import("/opt/carify/website/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/opt/carify/website/pages/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    component: () => import("/opt/carify/website/pages/blog/index.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    component: () => import("/opt/carify/website/pages/contact-us.vue")
  },
  {
    name: "contact-us___de",
    path: "/de/contact-us",
    component: () => import("/opt/carify/website/pages/contact-us.vue")
  },
  {
    name: "contact-us___fr",
    path: "/fr/contact-us",
    component: () => import("/opt/carify/website/pages/contact-us.vue")
  },
  {
    name: "contact-us___it",
    path: "/it/contact-us",
    component: () => import("/opt/carify/website/pages/contact-us.vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/opt/carify/website/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___de",
    path: "/de/blog/:slug()",
    component: () => import("/opt/carify/website/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    component: () => import("/opt/carify/website/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    component: () => import("/opt/carify/website/pages/blog/[slug].vue")
  },
  {
    name: "try-and-buy___en",
    path: "/en/try-and-buy",
    component: () => import("/opt/carify/website/pages/try-and-buy.vue")
  },
  {
    name: "try-and-buy___de",
    path: "/de/try-and-buy",
    component: () => import("/opt/carify/website/pages/try-and-buy.vue")
  },
  {
    name: "try-and-buy___fr",
    path: "/fr/try-and-buy",
    component: () => import("/opt/carify/website/pages/try-and-buy.vue")
  },
  {
    name: "try-and-buy___it",
    path: "/it/try-and-buy",
    component: () => import("/opt/carify/website/pages/try-and-buy.vue")
  },
  {
    name: "users-login___en",
    path: "/en/users/login",
    meta: { ...(loginkqWOgxsCqSYHhQcV3PsTY2Axfc4FpQok6javG_45qny6gMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/login.vue")
  },
  {
    name: "users-login___de",
    path: "/de/users/login",
    meta: { ...(loginkqWOgxsCqSYHhQcV3PsTY2Axfc4FpQok6javG_45qny6gMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/login.vue")
  },
  {
    name: "users-login___fr",
    path: "/fr/users/login",
    meta: { ...(loginkqWOgxsCqSYHhQcV3PsTY2Axfc4FpQok6javG_45qny6gMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/login.vue")
  },
  {
    name: "users-login___it",
    path: "/it/users/login",
    meta: { ...(loginkqWOgxsCqSYHhQcV3PsTY2Axfc4FpQok6javG_45qny6gMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/login.vue")
  },
  {
    name: "brands___en",
    path: "/en/brands",
    component: () => import("/opt/carify/website/pages/brands/index.vue")
  },
  {
    name: "brands___de",
    path: "/de/brands",
    component: () => import("/opt/carify/website/pages/brands/index.vue")
  },
  {
    name: "brands___fr",
    path: "/fr/brands",
    component: () => import("/opt/carify/website/pages/brands/index.vue")
  },
  {
    name: "brands___it",
    path: "/it/brands",
    component: () => import("/opt/carify/website/pages/brands/index.vue")
  },
  {
    name: "how-it-works___en",
    path: "/en/how-it-works",
    component: () => import("/opt/carify/website/pages/how-it-works.vue")
  },
  {
    name: "how-it-works___de",
    path: "/de/how-it-works",
    component: () => import("/opt/carify/website/pages/how-it-works.vue")
  },
  {
    name: "how-it-works___fr",
    path: "/fr/how-it-works",
    component: () => import("/opt/carify/website/pages/how-it-works.vue")
  },
  {
    name: "how-it-works___it",
    path: "/it/how-it-works",
    component: () => import("/opt/carify/website/pages/how-it-works.vue")
  },
  {
    name: "brands-slug___en",
    path: "/en/brands/:slug()",
    component: () => import("/opt/carify/website/pages/brands/[slug].vue")
  },
  {
    name: "brands-slug___de",
    path: "/de/brands/:slug()",
    component: () => import("/opt/carify/website/pages/brands/[slug].vue")
  },
  {
    name: "brands-slug___fr",
    path: "/fr/brands/:slug()",
    component: () => import("/opt/carify/website/pages/brands/[slug].vue")
  },
  {
    name: "brands-slug___it",
    path: "/it/brands/:slug()",
    component: () => import("/opt/carify/website/pages/brands/[slug].vue")
  },
  {
    name: "dealers___en",
    path: "/en/dealers",
    component: () => import("/opt/carify/website/pages/dealers/index.vue")
  },
  {
    name: "dealers___de",
    path: "/de/dealers",
    component: () => import("/opt/carify/website/pages/dealers/index.vue")
  },
  {
    name: "dealers___fr",
    path: "/fr/dealers",
    component: () => import("/opt/carify/website/pages/dealers/index.vue")
  },
  {
    name: "dealers___it",
    path: "/it/dealers",
    component: () => import("/opt/carify/website/pages/dealers/index.vue")
  },
  {
    name: "electric-cars___en",
    path: "/en/electric-cars",
    component: () => import("/opt/carify/website/pages/electric-cars.vue")
  },
  {
    name: "electric-cars___de",
    path: "/de/electric-cars",
    component: () => import("/opt/carify/website/pages/electric-cars.vue")
  },
  {
    name: "electric-cars___fr",
    path: "/fr/electric-cars",
    component: () => import("/opt/carify/website/pages/electric-cars.vue")
  },
  {
    name: "electric-cars___it",
    path: "/it/electric-cars",
    component: () => import("/opt/carify/website/pages/electric-cars.vue")
  },
  {
    name: "users-profile___en",
    path: "/en/users/profile",
    meta: { ...(profileXqmjesIGbqoiW09Hl4C57i3du_45blzL5fgrr_huLBIvMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/profile.vue")
  },
  {
    name: "users-profile___de",
    path: "/de/users/profile",
    meta: { ...(profileXqmjesIGbqoiW09Hl4C57i3du_45blzL5fgrr_huLBIvMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/profile.vue")
  },
  {
    name: "users-profile___fr",
    path: "/fr/users/profile",
    meta: { ...(profileXqmjesIGbqoiW09Hl4C57i3du_45blzL5fgrr_huLBIvMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/profile.vue")
  },
  {
    name: "users-profile___it",
    path: "/it/users/profile",
    meta: { ...(profileXqmjesIGbqoiW09Hl4C57i3du_45blzL5fgrr_huLBIvMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/profile.vue")
  },
  {
    name: "users-sign-up___en",
    path: "/en/users/sign-up",
    meta: { ...(sign_45upXUCNoxxLcBxo1akWRtU8h_45tcWAWUOqbqaQF4qwbyUEcMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/sign-up.vue")
  },
  {
    name: "users-sign-up___de",
    path: "/de/users/sign-up",
    meta: { ...(sign_45upXUCNoxxLcBxo1akWRtU8h_45tcWAWUOqbqaQF4qwbyUEcMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/sign-up.vue")
  },
  {
    name: "users-sign-up___fr",
    path: "/fr/users/sign-up",
    meta: { ...(sign_45upXUCNoxxLcBxo1akWRtU8h_45tcWAWUOqbqaQF4qwbyUEcMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/sign-up.vue")
  },
  {
    name: "users-sign-up___it",
    path: "/it/users/sign-up",
    meta: { ...(sign_45upXUCNoxxLcBxo1akWRtU8h_45tcWAWUOqbqaQF4qwbyUEcMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/carify/website/pages/users/sign-up.vue")
  },
  {
    name: "dealers-slug___en",
    path: "/en/dealers/:slug()",
    component: () => import("/opt/carify/website/pages/dealers/[slug].vue")
  },
  {
    name: "dealers-slug___de",
    path: "/de/dealers/:slug()",
    component: () => import("/opt/carify/website/pages/dealers/[slug].vue")
  },
  {
    name: "dealers-slug___fr",
    path: "/fr/dealers/:slug()",
    component: () => import("/opt/carify/website/pages/dealers/[slug].vue")
  },
  {
    name: "dealers-slug___it",
    path: "/it/dealers/:slug()",
    component: () => import("/opt/carify/website/pages/dealers/[slug].vue")
  },
  {
    name: "expat-auto-abo___en",
    path: "/en/expat-auto-abo",
    component: () => import("/opt/carify/website/pages/expat-auto-abo.vue")
  },
  {
    name: "expat-auto-abo___de",
    path: "/de/expat-auto-abo",
    component: () => import("/opt/carify/website/pages/expat-auto-abo.vue")
  },
  {
    name: "expat-auto-abo___fr",
    path: "/fr/expat-auto-abo",
    component: () => import("/opt/carify/website/pages/expat-auto-abo.vue")
  },
  {
    name: "expat-auto-abo___it",
    path: "/it/expat-auto-abo",
    component: () => import("/opt/carify/website/pages/expat-auto-abo.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/opt/carify/website/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/opt/carify/website/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/opt/carify/website/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/opt/carify/website/pages/privacy-policy.vue")
  },
  {
    name: "search-vehicles___en",
    path: "/en/search-vehicles",
    meta: search_45vehicles_n2S9PO7bp4vYqAIG7PUA7QQmprmxS3Q9UsMzhFMK_4Meta || {},
    component: () => import("/opt/carify/website/pages/search-vehicles.vue")
  },
  {
    name: "search-vehicles___de",
    path: "/de/search-vehicles",
    meta: search_45vehicles_n2S9PO7bp4vYqAIG7PUA7QQmprmxS3Q9UsMzhFMK_4Meta || {},
    component: () => import("/opt/carify/website/pages/search-vehicles.vue")
  },
  {
    name: "search-vehicles___fr",
    path: "/fr/search-vehicles",
    meta: search_45vehicles_n2S9PO7bp4vYqAIG7PUA7QQmprmxS3Q9UsMzhFMK_4Meta || {},
    component: () => import("/opt/carify/website/pages/search-vehicles.vue")
  },
  {
    name: "search-vehicles___it",
    path: "/it/search-vehicles",
    meta: search_45vehicles_n2S9PO7bp4vYqAIG7PUA7QQmprmxS3Q9UsMzhFMK_4Meta || {},
    component: () => import("/opt/carify/website/pages/search-vehicles.vue")
  },
  {
    name: "vehicle-configs___en",
    path: "/en/vehicle-configs",
    meta: vehicle_45configs2wxUm5VnT_45O7oZxnQmGG8qq72LA5AL3n6ydeqfhjzjIMeta || {},
    component: () => import("/opt/carify/website/pages/vehicle-configs.vue")
  },
  {
    name: "vehicle-configs___de",
    path: "/de/vehicle-configs",
    meta: vehicle_45configs2wxUm5VnT_45O7oZxnQmGG8qq72LA5AL3n6ydeqfhjzjIMeta || {},
    component: () => import("/opt/carify/website/pages/vehicle-configs.vue")
  },
  {
    name: "vehicle-configs___fr",
    path: "/fr/vehicle-configs",
    meta: vehicle_45configs2wxUm5VnT_45O7oZxnQmGG8qq72LA5AL3n6ydeqfhjzjIMeta || {},
    component: () => import("/opt/carify/website/pages/vehicle-configs.vue")
  },
  {
    name: "vehicle-configs___it",
    path: "/it/vehicle-configs",
    meta: vehicle_45configs2wxUm5VnT_45O7oZxnQmGG8qq72LA5AL3n6ydeqfhjzjIMeta || {},
    component: () => import("/opt/carify/website/pages/vehicle-configs.vue")
  },
  {
    name: "vehicles-slug___en",
    path: "/en/vehicles/:slug()",
    component: () => import("/opt/carify/website/pages/vehicles/[slug].vue")
  },
  {
    name: "vehicles-slug___de",
    path: "/de/vehicles/:slug()",
    component: () => import("/opt/carify/website/pages/vehicles/[slug].vue")
  },
  {
    name: "vehicles-slug___fr",
    path: "/fr/vehicles/:slug()",
    component: () => import("/opt/carify/website/pages/vehicles/[slug].vue")
  },
  {
    name: "vehicles-slug___it",
    path: "/it/vehicles/:slug()",
    component: () => import("/opt/carify/website/pages/vehicles/[slug].vue")
  },
  {
    name: "become-a-partner___en",
    path: "/en/become-a-partner",
    component: () => import("/opt/carify/website/pages/become-a-partner.vue")
  },
  {
    name: "become-a-partner___de",
    path: "/de/become-a-partner",
    component: () => import("/opt/carify/website/pages/become-a-partner.vue")
  },
  {
    name: "become-a-partner___fr",
    path: "/fr/become-a-partner",
    component: () => import("/opt/carify/website/pages/become-a-partner.vue")
  },
  {
    name: "become-a-partner___it",
    path: "/it/become-a-partner",
    component: () => import("/opt/carify/website/pages/become-a-partner.vue")
  },
  {
    name: "compare-vehicles___en",
    path: "/en/compare-vehicles",
    component: () => import("/opt/carify/website/pages/compare-vehicles.vue")
  },
  {
    name: "compare-vehicles___de",
    path: "/de/compare-vehicles",
    component: () => import("/opt/carify/website/pages/compare-vehicles.vue")
  },
  {
    name: "compare-vehicles___fr",
    path: "/fr/compare-vehicles",
    component: () => import("/opt/carify/website/pages/compare-vehicles.vue")
  },
  {
    name: "compare-vehicles___it",
    path: "/it/compare-vehicles",
    component: () => import("/opt/carify/website/pages/compare-vehicles.vue")
  },
  {
    name: "view-slug-id___en",
    path: "/en/view/:slug()/:id()",
    component: () => import("/opt/carify/website/pages/view/[slug]/[id].vue")
  },
  {
    name: "view-slug-id___de",
    path: "/de/view/:slug()/:id()",
    component: () => import("/opt/carify/website/pages/view/[slug]/[id].vue")
  },
  {
    name: "view-slug-id___fr",
    path: "/fr/view/:slug()/:id()",
    component: () => import("/opt/carify/website/pages/view/[slug]/[id].vue")
  },
  {
    name: "view-slug-id___it",
    path: "/it/view/:slug()/:id()",
    component: () => import("/opt/carify/website/pages/view/[slug]/[id].vue")
  },
  {
    name: "affiliate-program___en",
    path: "/en/affiliate-program",
    component: () => import("/opt/carify/website/pages/affiliate-program.vue")
  },
  {
    name: "affiliate-program___de",
    path: "/de/affiliate-program",
    component: () => import("/opt/carify/website/pages/affiliate-program.vue")
  },
  {
    name: "affiliate-program___fr",
    path: "/fr/affiliate-program",
    component: () => import("/opt/carify/website/pages/affiliate-program.vue")
  },
  {
    name: "affiliate-program___it",
    path: "/it/affiliate-program",
    component: () => import("/opt/carify/website/pages/affiliate-program.vue")
  },
  {
    name: "business-customers___en",
    path: "/en/business-customers",
    component: () => import("/opt/carify/website/pages/business-customers.vue")
  },
  {
    name: "business-customers___de",
    path: "/de/business-customers",
    component: () => import("/opt/carify/website/pages/business-customers.vue")
  },
  {
    name: "business-customers___fr",
    path: "/fr/business-customers",
    component: () => import("/opt/carify/website/pages/business-customers.vue")
  },
  {
    name: "business-customers___it",
    path: "/it/business-customers",
    component: () => import("/opt/carify/website/pages/business-customers.vue")
  },
  {
    name: "users-verify_email___en",
    path: "/en/users/verify_email",
    meta: { ...(verify_emailPYck9TML1qvg5ShrxibWSwmOV2G5Rbt5S2rULEDFoFQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/verify_email.vue")
  },
  {
    name: "users-verify_email___de",
    path: "/de/users/verify_email",
    meta: { ...(verify_emailPYck9TML1qvg5ShrxibWSwmOV2G5Rbt5S2rULEDFoFQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/verify_email.vue")
  },
  {
    name: "users-verify_email___fr",
    path: "/fr/users/verify_email",
    meta: { ...(verify_emailPYck9TML1qvg5ShrxibWSwmOV2G5Rbt5S2rULEDFoFQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/verify_email.vue")
  },
  {
    name: "users-verify_email___it",
    path: "/it/users/verify_email",
    meta: { ...(verify_emailPYck9TML1qvg5ShrxibWSwmOV2G5Rbt5S2rULEDFoFQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/verify_email.vue")
  },
  {
    name: "book_now-slug-id___en",
    path: "/en/book_now/:slug()/:id()",
    meta: { ...(_91id_93twlqyNVeGpv7Sa6_PnJiS0ASZ5lhjJUZ_452OhCKSLWSUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/book_now/[slug]/[id].vue")
  },
  {
    name: "book_now-slug-id___de",
    path: "/de/book_now/:slug()/:id()",
    meta: { ...(_91id_93twlqyNVeGpv7Sa6_PnJiS0ASZ5lhjJUZ_452OhCKSLWSUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/book_now/[slug]/[id].vue")
  },
  {
    name: "book_now-slug-id___fr",
    path: "/fr/book_now/:slug()/:id()",
    meta: { ...(_91id_93twlqyNVeGpv7Sa6_PnJiS0ASZ5lhjJUZ_452OhCKSLWSUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/book_now/[slug]/[id].vue")
  },
  {
    name: "book_now-slug-id___it",
    path: "/it/book_now/:slug()/:id()",
    meta: { ...(_91id_93twlqyNVeGpv7Sa6_PnJiS0ASZ5lhjJUZ_452OhCKSLWSUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/book_now/[slug]/[id].vue")
  },
  {
    name: "brands-brand-abo___en",
    path: "/en/brands/:brand()/:abo()",
    component: () => import("/opt/carify/website/pages/brands/[brand]/[abo].vue")
  },
  {
    name: "brands-brand-abo___de",
    path: "/de/brands/:brand()/:abo()",
    component: () => import("/opt/carify/website/pages/brands/[brand]/[abo].vue")
  },
  {
    name: "brands-brand-abo___fr",
    path: "/fr/brands/:brand()/:abo()",
    component: () => import("/opt/carify/website/pages/brands/[brand]/[abo].vue")
  },
  {
    name: "brands-brand-abo___it",
    path: "/it/brands/:brand()/:abo()",
    component: () => import("/opt/carify/website/pages/brands/[brand]/[abo].vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("/opt/carify/website/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___de",
    path: "/de/terms-and-conditions",
    component: () => import("/opt/carify/website/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___fr",
    path: "/fr/terms-and-conditions",
    component: () => import("/opt/carify/website/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___it",
    path: "/it/terms-and-conditions",
    component: () => import("/opt/carify/website/pages/terms-and-conditions.vue")
  },
  {
    name: "users-reset_password___en",
    path: "/en/users/reset_password",
    meta: reset_passwordV9ZMZ_49agJTbQh0dWX2Ap6sMgSJwqDI2GFK7vE2ddoMeta || {},
    component: () => import("/opt/carify/website/pages/users/reset_password.vue")
  },
  {
    name: "users-reset_password___de",
    path: "/de/users/reset_password",
    meta: reset_passwordV9ZMZ_49agJTbQh0dWX2Ap6sMgSJwqDI2GFK7vE2ddoMeta || {},
    component: () => import("/opt/carify/website/pages/users/reset_password.vue")
  },
  {
    name: "users-reset_password___fr",
    path: "/fr/users/reset_password",
    meta: reset_passwordV9ZMZ_49agJTbQh0dWX2Ap6sMgSJwqDI2GFK7vE2ddoMeta || {},
    component: () => import("/opt/carify/website/pages/users/reset_password.vue")
  },
  {
    name: "users-reset_password___it",
    path: "/it/users/reset_password",
    meta: reset_passwordV9ZMZ_49agJTbQh0dWX2Ap6sMgSJwqDI2GFK7vE2ddoMeta || {},
    component: () => import("/opt/carify/website/pages/users/reset_password.vue")
  },
  {
    name: "users-forgot_password___en",
    path: "/en/users/forgot_password",
    meta: forgot_passwordA5X0NpL0Q91Eug_OM9mEyH3o3VZVe_45UtGIsDCV4svdgMeta || {},
    component: () => import("/opt/carify/website/pages/users/forgot_password.vue")
  },
  {
    name: "users-forgot_password___de",
    path: "/de/users/forgot_password",
    meta: forgot_passwordA5X0NpL0Q91Eug_OM9mEyH3o3VZVe_45UtGIsDCV4svdgMeta || {},
    component: () => import("/opt/carify/website/pages/users/forgot_password.vue")
  },
  {
    name: "users-forgot_password___fr",
    path: "/fr/users/forgot_password",
    meta: forgot_passwordA5X0NpL0Q91Eug_OM9mEyH3o3VZVe_45UtGIsDCV4svdgMeta || {},
    component: () => import("/opt/carify/website/pages/users/forgot_password.vue")
  },
  {
    name: "users-forgot_password___it",
    path: "/it/users/forgot_password",
    meta: forgot_passwordA5X0NpL0Q91Eug_OM9mEyH3o3VZVe_45UtGIsDCV4svdgMeta || {},
    component: () => import("/opt/carify/website/pages/users/forgot_password.vue")
  },
  {
    name: "users-km_request-id___en",
    path: "/en/users/km_request/:id()",
    meta: { ...(_91id_93p6o53tOruKklS99UxL41vMN7iqPAmZ_S3fSqytAr_45fQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/km_request/[id].vue")
  },
  {
    name: "users-km_request-id___de",
    path: "/de/users/km_request/:id()",
    meta: { ...(_91id_93p6o53tOruKklS99UxL41vMN7iqPAmZ_S3fSqytAr_45fQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/km_request/[id].vue")
  },
  {
    name: "users-km_request-id___fr",
    path: "/fr/users/km_request/:id()",
    meta: { ...(_91id_93p6o53tOruKklS99UxL41vMN7iqPAmZ_S3fSqytAr_45fQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/km_request/[id].vue")
  },
  {
    name: "users-km_request-id___it",
    path: "/it/users/km_request/:id()",
    meta: { ...(_91id_93p6o53tOruKklS99UxL41vMN7iqPAmZ_S3fSqytAr_45fQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/users/km_request/[id].vue")
  },
  {
    name: "claim_declarations-id___en",
    path: "/en/claim_declarations/:id()",
    meta: { ...(_91id_93wmvCnfyhxlrhU9AG3fpGHF4WQRDBuYXeImE_45Z_45mXiiIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/claim_declarations/[id].vue")
  },
  {
    name: "claim_declarations-id___de",
    path: "/de/claim_declarations/:id()",
    meta: { ...(_91id_93wmvCnfyhxlrhU9AG3fpGHF4WQRDBuYXeImE_45Z_45mXiiIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/claim_declarations/[id].vue")
  },
  {
    name: "claim_declarations-id___fr",
    path: "/fr/claim_declarations/:id()",
    meta: { ...(_91id_93wmvCnfyhxlrhU9AG3fpGHF4WQRDBuYXeImE_45Z_45mXiiIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/claim_declarations/[id].vue")
  },
  {
    name: "claim_declarations-id___it",
    path: "/it/claim_declarations/:id()",
    meta: { ...(_91id_93wmvCnfyhxlrhU9AG3fpGHF4WQRDBuYXeImE_45Z_45mXiiIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/claim_declarations/[id].vue")
  },
  {
    name: "claim_shared_files-id___en",
    path: "/en/claim_shared_files/:id()",
    meta: _91id_93DX7a3psfI0FwBl2MGhl3XASqmL_45nn00w83ShxLVRMrIMeta || {},
    component: () => import("/opt/carify/website/pages/claim_shared_files/[id].vue")
  },
  {
    name: "claim_shared_files-id___de",
    path: "/de/claim_shared_files/:id()",
    meta: _91id_93DX7a3psfI0FwBl2MGhl3XASqmL_45nn00w83ShxLVRMrIMeta || {},
    component: () => import("/opt/carify/website/pages/claim_shared_files/[id].vue")
  },
  {
    name: "claim_shared_files-id___fr",
    path: "/fr/claim_shared_files/:id()",
    meta: _91id_93DX7a3psfI0FwBl2MGhl3XASqmL_45nn00w83ShxLVRMrIMeta || {},
    component: () => import("/opt/carify/website/pages/claim_shared_files/[id].vue")
  },
  {
    name: "claim_shared_files-id___it",
    path: "/it/claim_shared_files/:id()",
    meta: _91id_93DX7a3psfI0FwBl2MGhl3XASqmL_45nn00w83ShxLVRMrIMeta || {},
    component: () => import("/opt/carify/website/pages/claim_shared_files/[id].vue")
  },
  {
    name: "frequently-asked-questions___en",
    path: "/en/frequently-asked-questions",
    component: () => import("/opt/carify/website/pages/frequently-asked-questions.vue")
  },
  {
    name: "frequently-asked-questions___de",
    path: "/de/frequently-asked-questions",
    component: () => import("/opt/carify/website/pages/frequently-asked-questions.vue")
  },
  {
    name: "frequently-asked-questions___fr",
    path: "/fr/frequently-asked-questions",
    component: () => import("/opt/carify/website/pages/frequently-asked-questions.vue")
  },
  {
    name: "frequently-asked-questions___it",
    path: "/it/frequently-asked-questions",
    component: () => import("/opt/carify/website/pages/frequently-asked-questions.vue")
  },
  {
    name: "short-term-car-subscription___en",
    path: "/en/short-term-car-subscription",
    component: () => import("/opt/carify/website/pages/short-term-car-subscription.vue")
  },
  {
    name: "short-term-car-subscription___de",
    path: "/de/short-term-car-subscription",
    component: () => import("/opt/carify/website/pages/short-term-car-subscription.vue")
  },
  {
    name: "short-term-car-subscription___fr",
    path: "/fr/short-term-car-subscription",
    component: () => import("/opt/carify/website/pages/short-term-car-subscription.vue")
  },
  {
    name: "short-term-car-subscription___it",
    path: "/it/short-term-car-subscription",
    component: () => import("/opt/carify/website/pages/short-term-car-subscription.vue")
  },
  {
    name: "tyrechange_appointment-id___en",
    path: "/en/tyrechange_appointment/:id()",
    meta: { ...(_91id_93Gp72a6FdLnvaEoC0DjlwPqnSeTj0Y1jnL991IiCk8aUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/tyrechange_appointment/[id].vue")
  },
  {
    name: "tyrechange_appointment-id___de",
    path: "/de/tyrechange_appointment/:id()",
    meta: { ...(_91id_93Gp72a6FdLnvaEoC0DjlwPqnSeTj0Y1jnL991IiCk8aUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/tyrechange_appointment/[id].vue")
  },
  {
    name: "tyrechange_appointment-id___fr",
    path: "/fr/tyrechange_appointment/:id()",
    meta: { ...(_91id_93Gp72a6FdLnvaEoC0DjlwPqnSeTj0Y1jnL991IiCk8aUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/tyrechange_appointment/[id].vue")
  },
  {
    name: "tyrechange_appointment-id___it",
    path: "/it/tyrechange_appointment/:id()",
    meta: { ...(_91id_93Gp72a6FdLnvaEoC0DjlwPqnSeTj0Y1jnL991IiCk8aUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/tyrechange_appointment/[id].vue")
  },
  {
    name: "booking_document_request-id___en",
    path: "/en/booking_document_request/:id()",
    meta: { ...(_91id_93Jw0FpKgxUJebrcj2gLWcbquEL5JjieyUcf5OW9hknZIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/booking_document_request/[id].vue")
  },
  {
    name: "booking_document_request-id___de",
    path: "/de/booking_document_request/:id()",
    meta: { ...(_91id_93Jw0FpKgxUJebrcj2gLWcbquEL5JjieyUcf5OW9hknZIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/booking_document_request/[id].vue")
  },
  {
    name: "booking_document_request-id___fr",
    path: "/fr/booking_document_request/:id()",
    meta: { ...(_91id_93Jw0FpKgxUJebrcj2gLWcbquEL5JjieyUcf5OW9hknZIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/booking_document_request/[id].vue")
  },
  {
    name: "booking_document_request-id___it",
    path: "/it/booking_document_request/:id()",
    meta: { ...(_91id_93Jw0FpKgxUJebrcj2gLWcbquEL5JjieyUcf5OW9hknZIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/carify/website/pages/booking_document_request/[id].vue")
  },
  {
    name: "car-for-students-in-switzerland___en",
    path: "/en/car-for-students-in-switzerland",
    component: () => import("/opt/carify/website/pages/car-for-students-in-switzerland.vue")
  },
  {
    name: "car-for-students-in-switzerland___de",
    path: "/de/car-for-students-in-switzerland",
    component: () => import("/opt/carify/website/pages/car-for-students-in-switzerland.vue")
  },
  {
    name: "car-for-students-in-switzerland___fr",
    path: "/fr/car-for-students-in-switzerland",
    component: () => import("/opt/carify/website/pages/car-for-students-in-switzerland.vue")
  },
  {
    name: "car-for-students-in-switzerland___it",
    path: "/it/car-for-students-in-switzerland",
    component: () => import("/opt/carify/website/pages/car-for-students-in-switzerland.vue")
  },
  {
    name: "long-term-car-subscription-switzerland___en",
    path: "/en/long-term-car-subscription-switzerland",
    component: () => import("/opt/carify/website/pages/long-term-car-subscription-switzerland.vue")
  },
  {
    name: "long-term-car-subscription-switzerland___de",
    path: "/de/long-term-car-subscription-switzerland",
    component: () => import("/opt/carify/website/pages/long-term-car-subscription-switzerland.vue")
  },
  {
    name: "long-term-car-subscription-switzerland___fr",
    path: "/fr/long-term-car-subscription-switzerland",
    component: () => import("/opt/carify/website/pages/long-term-car-subscription-switzerland.vue")
  },
  {
    name: "long-term-car-subscription-switzerland___it",
    path: "/it/long-term-car-subscription-switzerland",
    component: () => import("/opt/carify/website/pages/long-term-car-subscription-switzerland.vue")
  },
  {
    name: component_45stubfGHRWTin7UW9RdGD7KiDT1hVy5E2Q0cbky_45hmHtUduoMeta?.name,
    path: "/de_CH/:pathMatch(.*)",
    component: component_45stubfGHRWTin7UW9RdGD7KiDT1hVy5E2Q0cbky_45hmHtUduo
  }
]